module.exports = __webpack_public_path__ + "img/EgyptCapTechPtolemysMasonry.f3e5e2cb.webp";